import { StoredDocumentInformation } from "src/app/storage/models/stored-document-information";

/**
 * An instance of the StoredDocumentInformation model to be used for schema validation
 */
export const storedDocumentInformationInstance: StoredDocumentInformation = {
	LegacyId: 0,
	Page: 0,
	FileName: ""
}